import React, { HTMLAttributes, forwardRef, CSSProperties } from "react";
import { IItem } from ".";
import { PiFileCsvFill } from "react-icons/pi";
import { HiX } from "react-icons/hi";

interface IItemProps extends HTMLAttributes<HTMLDivElement> {
  item: IItem;
  isOpacityEnabled?: boolean;
  isDragging?: boolean;
  onRemove: (id: number) => void;
  onChangeFile?: (id: number, file: File) => void;
  open?: () => void;
}

const Item = forwardRef<HTMLDivElement, IItemProps>(
  (
    {
      item,
      onRemove,
      onChangeFile,
      open,
      isOpacityEnabled,
      isDragging,
      style,
      ...props
    },
    ref
  ) => {
    const styles: CSSProperties = {
      opacity: isOpacityEnabled ? "0.4" : "1",
      cursor: isDragging ? "grabbing" : "grab",
      lineHeight: "0.5",
      transform: isDragging ? "scale(1.05)" : "scale(1)",
      ...style,
    };

    return (
      <div
        className="group relative flex flex-col items-center justify-center gap-2 overflow-hidden rounded-xl border-[2px] border-dashed border-gray-200 px-3 py-3"
        ref={ref}
        style={styles}
        {...props}
      >
        {/* Remove Button */}
        <div
          className="absolute right-0 top-0 z-10 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-red-500"
          onClick={() => {
            onRemove(item.id);
          }}
        >
          <button
            type="button"
            className="absolute left-0 top-0 h-full w-full bg-transparent"
          />
          <HiX color="white" width={18} />
        </div>
        {/* End Remove Button */}
        {item.file ? (
          <>
            <div className="relative flex w-full items-center justify-center">
              {item.file instanceof File &&
              !item.file.type.startsWith("image/") ? (
                <PiFileCsvFill className="text-7xl text-brand-400" />
              ) : (
                <img
                  src={
                    item.file instanceof File
                      ? URL.createObjectURL(item.file)
                      : "https://placehold.co/600x400?text=No+File"
                  }
                  alt={item.file.name}
                  className="max-h-52 max-w-full rounded-lg object-cover object-center"
                  style={{
                    boxShadow: isDragging
                      ? "none"
                      : "rgb(63 63 68 / 5%) 0px 0px 0px 1px, rgb(34 33 81 / 15%) 0px 1px 3px 0px",
                  }}
                />
              )}
            </div>
            <p className="text-sm font-medium text-gray-600">
              {item.file.name}
            </p>
            <div className="flex items-center justify-center gap-2">
              <p className="text-sm font-medium text-gray-600">
                {item.file.size > 1024 * 1024
                  ? (item.file.size / (1024 * 1024)).toFixed(2) + " MB"
                  : item.file.size > 1024
                  ? (item.file.size / 1024).toFixed(2) + " KB"
                  : item.file.size + " B"}
              </p>
            </div>
          </>
        ) : (
          <div
            className="flex h-48 w-fit rounded-md border border-gray-300"
            key={item.id}
          >
            <img
              src={`
                ${
                  !item.path.startsWith("https")
                    ? `${process.env.REACT_APP_PUBLIC_URL}/${item.path}`
                    : item.path
                }`}
              alt={item.path}
              className="h-full w-full rounded-md object-cover"
            />
          </div>
        )}
        {/* <div className="mt-auto flex h-fit w-full cursor-pointer items-center justify-center rounded-xl bg-white bg-opacity-0 transition-all">
          <button
            type="button"
            className="w-max rounded-3xl bg-brand-900 px-3 py-2 text-white"
            onClick={() => {
              onChangeFile(item.id, null);
            }}
          >
            Click to change file
          </button>
        </div> */}
      </div>
    );
  }
);

export default Item;
